import React from "react";
import { styled } from "@mui/system";
import { ReactComponent as InfoIcon } from "../assets/icons/informationIcongrey.svg";
import { ReactComponent as VerifyEmail } from "../assets/icons/emailVerfication.svg";
import { ReactComponent as VerifyMobile } from "../assets/icons/phoneVerification.svg";
import { OtpChannel } from "../constants";

const StyledSectionTitleWithInfo = styled("div")(({ theme, smallInfo }) => ({
  "& .title": {
    display: "block",
    fontSize: "1.25rem",
    fontWeight: 500,
    lineHeight: "20px",
    color: "var(--Color-Text-Primary-On-Light, #1F1F1F)",
    margin: 0,
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.75rem",
      margin: 0,
      marginBottom: "8px",
      lineHeight: "32px"
    }
  },
  "& .info": {
    fontSize: "1rem",
    lineHeight: "24px",
    color: "#757575",
    display: "block",
    marginTop: 10,
    fontWeight: 400,
    [theme.breakpoints.only("xs")]: {
      fontSize: smallInfo ? "1rem" : "1.25rem",
      marginTop: smallInfo ? 5 : 10
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: smallInfo ? "1.125rem" : "1.25rem",
      margin: 0
    }
  },
  "& .infoWithIcon": {
    fontSize: "20px",
    fontStyle: "normal",
    lineHeight: "28px",
    color: "#757575",
    display: "block",
    fontWeight: 400,
    fontFamily: "Rakbank Sans",
    [theme.breakpoints.only("xs")]: {
      fontSize: smallInfo ? "1rem" : "1.25rem"
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "20px"
    }
  },
  "& .changeLink": {
    display: "block",
    marginTop: 16,
    textDecorationLine: "underline",
    color: "var(--Color-Text-Primary-On-Light, #1F1F1F)",
    fontSize: 14,
    lineHeight: "24px"
  },
  "& .titleInfo": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
    paddingBottom: "16px"
  },
  "& .otpInfoMessage": {
    display: "flex",
    padding: "24px",
    alignItems: "center",
    gap: "24px",
    alignSelf: "strech",
    borderRadius: "10px",
    background: "#F7F8F9"
  },
  "& .otpTypeIcon": {
    width: "54px",
    height: "54px",
    [theme.breakpoints.up("sm")]: {
      width: "72px",
      height: "72px"
    }
  },
  "& .icon": {
    width: "20px",
    height: "20px",
    minWidth: "20px",
    minHeight: "20px",
    [theme.breakpoints.up("sm")]: {
      width: "20px",
      height: "20px"
    }
  }
}));

export const SectionTitleWithInfo = ({
  className,
  title,
  info,
  smallInfo = false,
  changeText,
  showInfoIcon,
  otpType
}) => {
  return (
    <StyledSectionTitleWithInfo className={className} smallInfo={smallInfo}>
      {showInfoIcon && (
        <div className="titleInfo">
          {otpType === OtpChannel.Sms ? (
            <VerifyMobile className="otpTypeIcon" />
          ) : (
            <VerifyEmail className="otpTypeIcon" />
          )}
          <h3 className="title">{title}</h3>
        </div>
      )}
      {!showInfoIcon && <h3 className="title">{title}</h3>}
      {info && !showInfoIcon && <span className="info">{info}</span>}
      {showInfoIcon && info && (
        <div className="otpInfoMessage" data-testid="otpInfoMessage">
          <InfoIcon className="icon" />
          <span className="infoWithIcon">{info}</span>
        </div>
      )}
      {changeText && <span className="changeLink">{changeText}</span>}
    </StyledSectionTitleWithInfo>
  );
};
